import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=4bb30acb&scoped=true"
import script from "./BannerComponent.vue?vue&type=script&lang=js"
export * from "./BannerComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerComponent.vue?vue&type=style&index=0&id=4bb30acb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb30acb",
  null
  
)

export default component.exports